import { TOrder } from 'src/types/orders';
import { ORDER_STATUS } from 'src/constants/order';
import { AGGREGATOR_ORDER_SCHEME, OVERRIDE_ORDER_OPTIONS } from 'src/constants/aggregators';
import { DELIVERY_TYPE, ORDER_DELIVERY_TYPES } from '~/constants/deliveryTypes';

export const getNextStatus = (order: TOrder | undefined | null): ORDER_STATUS | undefined => {
  if (!order || !order.aggregator_key || !AGGREGATOR_ORDER_SCHEME.hasOwnProperty(order.aggregator_key)) {
    return undefined;
  }

  if (!AGGREGATOR_ORDER_SCHEME[order.aggregator_key].hasOwnProperty('statusSwitchButtonSteps')) {
    return undefined;
  }

  if (!AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusSwitchButtonSteps[order.order_status_code]) {
    return undefined;
  }

  const deliveryType = order.delivery_type_code === ORDER_DELIVERY_TYPES.PICKUP ? DELIVERY_TYPE.PICKUP : DELIVERY_TYPE.DELIVERY;

  if (!AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusSwitchButtonSteps[order.order_status_code][deliveryType]) {
    return undefined;
  }

  return AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusSwitchButtonSteps[order.order_status_code][deliveryType];
};

export const statusManagementAvailable = (order?: TOrder | null) => {
  if (!order || !order.aggregator_key) {
    return false;
  }

  if (!AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusManagment) {
    return false;
  }

  return Object.keys(AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusManagment).includes(order.order_status_code);
};

export const getAvailableOrderStatuses = (order?: TOrder | null): ORDER_STATUS[] => {
  if (!order || !order.aggregator_key || !statusManagementAvailable(order)) {
    return [];
  }

  const deliveryType = order.delivery_type_code === ORDER_DELIVERY_TYPES.PICKUP ? ORDER_DELIVERY_TYPES.PICKUP : ORDER_DELIVERY_TYPES.DELIVERY;

  if (!AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusManagment[order.order_status_code][deliveryType]) {
    return [];
  }

  return AGGREGATOR_ORDER_SCHEME[order.aggregator_key].statusManagment[order.order_status_code][deliveryType] as ORDER_STATUS[];
};

export const statusCouldBeChangedToNext = (
  aggregatorConstants: { [key: string]: any },
  orderDeliveryType?: ORDER_DELIVERY_TYPES | null,
  currentStatus?: ORDER_STATUS | null,
  nextStatus?: ORDER_STATUS | null
): boolean => {
  if (!currentStatus || !nextStatus || !aggregatorConstants[currentStatus]) {
    return false;
  }

  const deliveryType = orderDeliveryType === ORDER_DELIVERY_TYPES.PICKUP ? ORDER_DELIVERY_TYPES.PICKUP : ORDER_DELIVERY_TYPES.DELIVERY;

  if (!aggregatorConstants[currentStatus][deliveryType]) {
    return false;
  }

  return aggregatorConstants[currentStatus][deliveryType].includes(nextStatus);
};

export const overrideField = (order: TOrder, field: string, defaultValue: any) => {
  if (!order.aggregator_key || !OVERRIDE_ORDER_OPTIONS.hasOwnProperty(order.aggregator_key)) {
    return defaultValue;
  }

  if (!OVERRIDE_ORDER_OPTIONS[order.aggregator_key].hasOwnProperty(field)) {
    return defaultValue;
  }

  return OVERRIDE_ORDER_OPTIONS[order.aggregator_key][field];
};
